"use client";

import { c as _c } from "react/compiler-runtime";
import { RiCheckLine } from "react-icons/ri";
import Button from "@/components/ui/button";
import { cx } from "@/lib/tailwind-utils";
import { useFinishSetupChecklist } from "@/api/provider/setup-checklist/setup-checklist-query";
import { setupSidebarDefinition } from "@/features/sidebar/setup-sidebar";
import { useRightSidebarStore } from "@/stores/right-sidebar-store";
function closeSetupSidebar() {
  useRightSidebarStore.getState().close(setupSidebarDefinition.id);
}

/** Shown when nothing is open but the checklist is not yet finished. */
export function SetupChecklistComplete(t0) {
  const $ = _c(12);
  const {
    className
  } = t0;
  const finish = useFinishSetupChecklist();
  let t1;
  if ($[0] !== className) {
    t1 = cx("flex flex-col items-center gap-3 py-6 text-center", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="flex size-8 items-center justify-center rounded-full bg-foreground text-background"><RiCheckLine className="size-4" aria-hidden="true" /></span>;
    t3 = <p className="text-body-strong text-foreground">You're all set</p>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== finish) {
    t4 = () => finish.mutateAsync().then(closeSetupSidebar, _temp);
    $[4] = finish;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== finish.isPending || $[7] !== t4) {
    t5 = <Button variant="primary" size="sm" isLoading={finish.isPending} onClick={t4}>Finish setup</Button>;
    $[6] = finish.isPending;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t1 || $[10] !== t5) {
    t6 = <div className={t1}>{t2}{t3}{t5}</div>;
    $[9] = t1;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function _temp() {}